module.exports = __webpack_public_path__ + "static/media/image-6.b78eae80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-54/image-6.jpg
// module id = 274
// module chunks = 0